/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './dietas/dietas.component.ngfactory';
import * as i4 from './login/login.component.ngfactory';
import * as i5 from './login/novo-acesso/novo-acesso.component.ngfactory';
import * as i6 from './login/recuperar-senha/recuperar-senha.component.ngfactory';
import * as i7 from './app.component.ngfactory';
import * as i8 from '@angular/common';
import * as i9 from '@angular/platform-browser';
import * as i10 from '@angular/forms';
import * as i11 from '../../app/guards/c-dietas-deactivate.guard';
import * as i12 from '@angular/router';
import * as i13 from '@angular/http';
import * as i14 from '../../app/configs.service';
import * as i15 from '../../app/login/autentica.service';
import * as i16 from '../../app/trazPaciente.service';
import * as i17 from '../../app/guards/auth.guard';
import * as i18 from '../../app/guards/pacientes.guard';
import * as i19 from '../../app/guards/dietas.guard';
import * as i20 from '../../app/guards/paciente.guard';
import * as i21 from '../../app/utils.service';
import * as i22 from '../../app/dietas/dietas.component';
import * as i23 from '../../app/login/login.component';
import * as i24 from '../../app/login/novo-acesso/novo-acesso.component';
import * as i25 from '../../app/login/recuperar-senha/recuperar-senha.component';
import * as i26 from '../../app/dietas/dietas.rotas.module';
import * as i27 from '../../app/dietas/dietas.module';
import * as i28 from '../../app/app.rotas.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.DietasComponentNgFactory,i4.LoginComponentNgFactory,i5.NovoAcessoComponentNgFactory,
              i6.RecuperarSenhaComponentNgFactory,i7.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),
          i0.ɵmpd(4608,i8.NgLocalization,i8.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(5120,
              i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,i0.ɵk,
              ([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),
          i0.ɵmpd(4608,i9.DomSanitizer,i9.ɵe,[i9.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,
              (null as any),[i9.DomSanitizer]),i0.ɵmpd(4608,i9.HAMMER_GESTURE_CONFIG,
              i9.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,i9.EVENT_MANAGER_PLUGINS,
              (p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i9.ɵDomEventsPlugin(p0_0),new i9.ɵKeyEventsPlugin(p1_0),
                    new i9.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i9.DOCUMENT,i9.DOCUMENT,i9.DOCUMENT,i9.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i9.EventManager,i9.EventManager,[i9.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i9.ɵDomSharedStylesHost,i9.ɵDomSharedStylesHost,[i9.DOCUMENT]),
          i0.ɵmpd(4608,i9.ɵDomRendererFactory2,i9.ɵDomRendererFactory2,[i9.EventManager,
              i9.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,(null as any),
              [i9.ɵDomRendererFactory2]),i0.ɵmpd(6144,i9.ɵSharedStylesHost,(null as any),
              [i9.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,i0.Testability,
              [i0.NgZone]),i0.ɵmpd(4608,i9.Meta,i9.Meta,[i9.DOCUMENT]),i0.ɵmpd(4608,
              i9.Title,i9.Title,[i9.DOCUMENT]),i0.ɵmpd(4608,i10.ɵi,i10.ɵi,([] as any[])),
          i0.ɵmpd(4608,i10.FormBuilder,i10.FormBuilder,([] as any[])),i0.ɵmpd(4608,
              i11.CadastrarDietasDeactivateGuard,i11.CadastrarDietasDeactivateGuard,
              ([] as any[])),i0.ɵmpd(5120,i12.ActivatedRoute,i12.ɵf,[i12.Router]),
          i0.ɵmpd(4608,i12.NoPreloading,i12.NoPreloading,([] as any[])),i0.ɵmpd(6144,
              i12.PreloadingStrategy,(null as any),[i12.NoPreloading]),i0.ɵmpd(135680,
              i12.RouterPreloader,i12.RouterPreloader,[i12.Router,i0.NgModuleFactoryLoader,
                  i0.Compiler,i0.Injector,i12.PreloadingStrategy]),i0.ɵmpd(4608,i12.PreloadAllModules,
              i12.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i12.ROUTER_INITIALIZER,
              i12.ɵi,[i12.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i12.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i13.BrowserXhr,i13.BrowserXhr,([] as any[])),
          i0.ɵmpd(4608,i13.ResponseOptions,i13.BaseResponseOptions,([] as any[])),
          i0.ɵmpd(5120,i13.XSRFStrategy,i13.ɵb,([] as any[])),i0.ɵmpd(4608,i13.XHRBackend,
              i13.XHRBackend,[i13.BrowserXhr,i13.ResponseOptions,i13.XSRFStrategy]),
          i0.ɵmpd(4608,i13.RequestOptions,i13.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i13.Http,i13.ɵc,[i13.XHRBackend,i13.RequestOptions]),i0.ɵmpd(4608,i14.ConfigsService,
              i14.ConfigsService,[i13.Http]),i0.ɵmpd(4608,i15.AutenticaService,i15.AutenticaService,
              [i12.Router,i13.Http,i14.ConfigsService]),i0.ɵmpd(4608,i16.TrazPaciente,
              i16.TrazPaciente,[i13.Http,i14.ConfigsService]),i0.ɵmpd(4608,i17.AuthGuard,
              i17.AuthGuard,[i15.AutenticaService,i12.Router]),i0.ɵmpd(4608,i18.PacientesGuard,
              i18.PacientesGuard,([] as any[])),i0.ɵmpd(4608,i19.DietasGuard,i19.DietasGuard,
              ([] as any[])),i0.ɵmpd(4608,i20.PacienteGuard,i20.PacienteGuard,([] as any[])),
          i0.ɵmpd(4608,i21.UtilsService,i21.UtilsService,([] as any[])),i0.ɵmpd(512,
              i8.CommonModule,i8.CommonModule,([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,
              i9.ɵa,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i12.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i12.ɵg,i12.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i9.ɵc(p0_0,p0_1),i12.ɵh(p1_0)];
              },[[2,i9.NgProbeToken],[2,i0.NgProbeToken],i12.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i9.BrowserModule,i9.BrowserModule,[[3,i9.BrowserModule]]),i0.ɵmpd(512,
              i10.ɵba,i10.ɵba,([] as any[])),i0.ɵmpd(512,i10.FormsModule,i10.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i10.ReactiveFormsModule,i10.ReactiveFormsModule,
              ([] as any[])),i0.ɵmpd(1024,i12.ɵa,i12.ɵd,[[3,i12.Router]]),i0.ɵmpd(512,
              i12.UrlSerializer,i12.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,
              i12.ChildrenOutletContexts,i12.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(512,i8.LocationStrategy,i8.HashLocationStrategy,[i8.PlatformLocation,
              [2,i8.APP_BASE_HREF]]),i0.ɵmpd(512,i8.Location,i8.Location,[i8.LocationStrategy]),
          i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i12.ROUTES,() => {
            return [[{path:'',component:i22.DietasComponent,canActivate:[i17.AuthGuard]},
                {path:'cadastrar',loadChildren:'./cadastrar/cadastrar.module.ts#DietasCadastrarModule',
                    canDeactivate:[i11.CadastrarDietasDeactivateGuard]},{path:'cadastrar/paciente/:codPaciente',
                    loadChildren:'./cadastrar/cadastrar.module.ts#DietasCadastrarModule',
                    canDeactivate:[i11.CadastrarDietasDeactivateGuard]},{path:'editar/dieta/:codDieta',
                    loadChildren:'./cadastrar/cadastrar.module.ts#DietasCadastrarModule',
                    canDeactivate:[i11.CadastrarDietasDeactivateGuard]}],[{path:'',
                component:i22.DietasComponent,canActivate:[i17.AuthGuard]},{path:'login',
                component:i23.LoginComponent},{path:'novo',component:i24.NovoAcessoComponent},
                {path:'recuperar-senha',component:i25.RecuperarSenhaComponent},{path:'pacientes',
                    loadChildren:'app/pacientes/pacientes.module.ts#PacientesModule',
                    canActivate:[i17.AuthGuard],canActivateChild:[i18.PacientesGuard]},
                {path:'paciente',loadChildren:'app/paciente/paciente.module.ts#PacienteModule',
                    canActivate:[i17.AuthGuard],canActivateChild:[i20.PacienteGuard]},
                {path:'dietas',loadChildren:'app/dietas/dietas.module.ts#DietasModule',
                    canActivate:[i17.AuthGuard],canActivateChild:[i19.DietasGuard]},
                {path:'altera-senha',loadChildren:'app/altera-senha/altera-senha.module.ts#AlteraSenhaModule',
                    canActivate:[i17.AuthGuard]}]];
          },([] as any[])),i0.ɵmpd(256,i12.ROUTER_CONFIGURATION,{},([] as any[])),
          i0.ɵmpd(1024,i12.Router,i12.ɵe,[i0.ApplicationRef,i12.UrlSerializer,i12.ChildrenOutletContexts,
              i8.Location,i0.Injector,i0.NgModuleFactoryLoader,i0.Compiler,i12.ROUTES,
              i12.ROUTER_CONFIGURATION,[2,i12.UrlHandlingStrategy],[2,i12.RouteReuseStrategy]]),
          i0.ɵmpd(512,i12.RouterModule,i12.RouterModule,[[2,i12.ɵa],[2,i12.Router]]),
          i0.ɵmpd(512,i26.DietasRotasModule,i26.DietasRotasModule,([] as any[])),i0.ɵmpd(512,
              i27.DietasModule,i27.DietasModule,([] as any[])),i0.ɵmpd(512,i28.AppRotasModule,
              i28.AppRotasModule,([] as any[])),i0.ɵmpd(512,i13.HttpModule,i13.HttpModule,
              ([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9hcHAubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9hcHAubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts